import APIServiceLookUp from './serviceAPI';
import { API_URL, MAIN_API_URL } from './models/AppConstent';

export default class ServiceOutlet {
    lookupService = new APIServiceLookUp();

    async getOutletById(body) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}outlet/getOutletById`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, '');
    }

    async updateOutletById(body) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}outlet/updateOutletById`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, '');
    }

    async getSubByFilter(body) {
        var serviceType = "POST";
        var url = `${API_URL}subscription/getSubByFilter`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, '');
    }
}